module.exports = __webpack_public_path__ + "static/img/LK@3x.81f03fdf.jpg";